import React, { useState } from 'react'
import './FaultSecondPageCustom_Coral.css';
import { useEffect, useMemo } from 'react';
import "./Horizantal_Coral.css"
import * as $ from 'jquery';
 
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitialstates_coral';
import NoData_Coral from '../../Driveanalysis_Coral/NoData_Coral';
import WaterMark from '../../DashboardMain_Coral/WaterMark';
 
export default function FaultSecondPageDataBars_Coral(props) {
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [falutBar, setFaultBar] = useState([]);
    const [falutBarNew, setFaultBarNew] = useState([]);
    const [falutBarUFA, setFaultBarUFA] = useState([]);
    const [falutBarUAA, setFaultBarUAA] = useState([]);
    const [falutBarUDA, setFaultBarUDA] = useState([]);
    const [UFAPercent, setUFAPercent] = useState([]);
    const [UAAPercent, setUAAPercent] = useState([]);
    const [UDAPercent, setUDAPercent] = useState([]);
    const [faultPercent, setFaultPercent] = useState([]);
    const [faultNewPercent, setFaultNewPercent] = useState([]);
    const [faultSelected, setFaultSelected] = useState('occurrence')//occurrence
    // const [tableTitle, setTableTitle] = useState("Mins");//Occurrence
    const [tableTitle, setTableTitle] = useState("Distinct Signals");//Occurrence
 
    const changeFault = (selectOp) => {
        setFaultSelected(selectOp);
        if (selectOp == "occurrence") {
            setTableTitle("Occurrence")
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/barFaultAnanysis', body: { selected: 'occurrence', startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num } }, responceData);
        } else {
            setTableTitle("Distinct Signals")
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/barUniqueFaultAnalysis', body: { startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num } }, responceDataUFA);
           
     
        }
    }
 
    function addECU(dataArr, chngKey) {
    const mainECU = ["BCS", "BMS", "DCDC", "MCU", "OBC", "VCU"];
 
    // Step 1: Filter out unwanted ECUs
    let filteredArr = dataArr.filter(item => mainECU.includes(item.key.ECU));
 
    // Step 2: Add any missing ECUs with 0 value
    mainECU.forEach(element => {
        var index = filteredArr.findIndex(x => x.key.ECU === element);
        if (index === -1) {
            filteredArr.push({
                "key": { "ECU": element },
                "doc_count": 0,
                [`${chngKey}`]: { "value": 0 }
            });
        }
    });
 
    // Step 3: Sort alphabetically
    let dataA = filteredArr.sort((a, b) => a.key.ECU.localeCompare(b.key.ECU));
    return dataA;
}
    function addECUPercent(arr) {
        const max_value = Math.max.apply(Math, arr.map(function (o) { return o.L4_Signal_Name.value; }));
        let percentArr = [];
        arr.map((val, i) => {
            var percent = Math.ceil((val.L4_Signal_Name.value / max_value) * 100);
            percentArr.push(isNaN(percent) ? 0 : percent);
        })
        return percentArr
    }
    function addECUPercentFault(arr) {
        const max_value = Math.max.apply(Math, arr.map(function (o) { return o.occ.value; }));
        let percentArr = [];
        arr.map((val, i) => {
            var percent = Math.ceil((val.occ.value / max_value) * 100);
            percentArr.push(isNaN(percent) ? 0 : percent);
        })
        return percentArr
    }
    function addECUPercentFaultNew(arr) {
        const max_value = Math.max.apply(Math, arr.map(function (o) { return o.rating.value; }));
        let percentArr = [];
        arr.map((val, i) => {
            var percent = Math.ceil((val.rating.value / max_value) * 100);
            percentArr.push(isNaN(percent) ? 0 : percent);
        })
        return percentArr
    }
 
    const responceData = (data) => {
        const ecu = addECU(data, "occ");
        setFaultPercent(addECUPercentFault(ecu));
        setFaultBar(ecu);
    }
    const responceDataUFA = (data) => {
        const ecu = addECU(data, "L4_Signal_Name");
        setUFAPercent(addECUPercent(ecu));
        setFaultBarUFA(ecu);
    }
    const responceDataUAA = (data) => {
        const ecu = addECU(data, "L4_Signal_Name");
        setUAAPercent(addECUPercent(ecu));
        setFaultBarUAA(ecu);
    }
    const responceDataUDA = (data) => {
        const ecu = addECU(data, "L4_Signal_Name");
        setUDAPercent(addECUPercent(ecu));
        setFaultBarUDA(ecu);
    }
   const responceDataNew = (data) => {
    const mainKeys = ["BCS", "BMS", "DCDC", "MCU", "OBC", "VCU"];
    const obj = data[0] || {};
    const finalArr = [];
 
    mainKeys.forEach((key) => {
        finalArr.push({
            name: key,
            rating: obj[key] ? obj[key] : { value: 0 }
        });
    });
 
    finalArr.sort((a, b) => a.name.localeCompare(b.name));
    setFaultBarNew(finalArr);
    setFaultNewPercent(addECUPercentFaultNew(finalArr));
};
 
    useEffect(() => {
        let body = { startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate,vin_num: Array.isArray(props.gloablfilter.vin_num)
    ? props.gloablfilter.vin_num
    : [props.gloablfilter.vin_num]}
        if (faultSelected == "occurrence") {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/barFaultAnanysis', body: { ...body, selected: 'occurrence' } }, responceData);
        } else {
            fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/barUniqueFaultAnalysis', body: body }, responceDataUFA);
        }
        fetchData({ url: API_URL_MAIN + 'coral_fault_analysis/barFaultAnanysis', body: { ...body, selected: 'duration' } }, responceDataNew);
    }, [props])
 
   
 
    function generateBarGraph(wrapper) {
        var values = [];
        $(wrapper + ' .bar').each(function (index, el) {
            values.push($(this).data('value'));
        });
        var max_value = Math.max.apply(Math, values);
        $(wrapper + ' .bar').each(function (index, el) {
            var bar = $(this),
                value = bar.data('value'),
                percent = Math.ceil((value / max_value) * 100);
            bar.addClass('in');
        });
    }
 
    useEffect(() => {
        generateBarGraph('#dashboard-stats');
        generateBarGraph('#dashboard-statsUFA');
        generateBarGraph('#dashboard-statsUAA');
        generateBarGraph('#dashboard-statsUDA');
    }, [falutBar, falutBarNew, falutBarUFA, falutBarUAA, falutBarUDA])
 
    return (
        <div className="row">
            <div className="col-md-6 col-sm-12 mb-3 px-2">
                <div className="v-title chartbox">
                    <div className="row">
                        <div className="col-md-12 col-sm-6 col-lg-7">
                            <div className="titlebg" style={{ marginBottom: "5px" }}>Fault Analysis</div>
                        </div>
                        <div className="col-md-12 col-sm-6 col-lg-5">
                            <select className="form-select form-select-sm" aria-label="Default select example" onChange={(event) => changeFault(event.target.value)}
                                value={faultSelected}>
                                <option value="duration">Distinct</option>
                                <option value="occurrence">Occurrence</option>
                            </select>
                        </div>
                    </div>
                    <div className="chartHGT">
                        <div className="boxHead">
                            <div className="float-start">
                                <p className=" boxHeadText">ECU</p>
                            </div>
                            <div className="float-end">
                                <p className="boxHeadText">{tableTitle}</p>
                            </div>
                        </div>
                        <div className="chart-wrap">
                             <div style={{ maxHeight: "260px", overflowY: "auto" }}>
                            <WaterMark />
                            <div id="dashboard-statsUFA" className="chart bars-horizontal brand-primary">
                                {
                                    faultSelected === "occurrence" ?
                                        falutBar.map((val, i) => <div className="row" key={i}>
                                            <span className="label">{val.key.ECU}</span>
                                            <div className="bar-wrap">
                                                <div className="bar" data-value={val.occ.value} style={{ width: faultPercent[i] + "%" }} />
                                            </div>
                                            <span className="number">{val.occ.value}</span>
                                        </div>)
                                        :
                                        falutBarUFA.map((val, i) => <div className="row" key={i}>
                                            <span className="label">{val.key.ECU}</span>
                                            <div className="bar-wrap">
                                                <div className="bar" data-value={val.L4_Signal_Name.value} style={{ width: UFAPercent[i] + "%" }} />
                                            </div>
                                            <span className="number">{val.L4_Signal_Name.value}</span>
                                        </div>)
                                }
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-sm-12 mb-3 px-2">
                <div className="v-title chartbox">
                    <div className="titlebg">Fault Duration Analysis</div>
                    <div className="chartHGT">
                        <div className="boxHead">
                            <div className="float-start">
                                <p className=" boxHeadText">ECU</p>
                            </div>
                            <div className="float-end">
                                <p className="boxHeadText">Mins</p>
                            </div>
                        </div>
                        <div className="chart-wrap">
                            <WaterMark />
                            <div id="dashboard-stats" className="chart bars-horizontal brand-primary">
                                {
                                    falutBarNew.map((val, i) => <div className="row" key={i}>
                                        <span className="label">{val.name}</span>
                                        <div className="bar-wrap">
                                            <div className="bar" data-value={val.rating.value} style={{ width: faultNewPercent[i] + "%" }} />
                                        </div>
                                        <span className="number">{val.rating.value}</span>
                                    </div>)
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}